// extracted by mini-css-extract-plugin
module.exports = {"root":"SliderContainer_root__LaH2m container-bleed","wrapper":"SliderContainer_wrapper__2yApZ row"};